import { render, staticRenderFns } from "./TableauTest.vue?vue&type=template&id=38b91cef&"
import script from "./TableauTest.vue?vue&type=script&lang=js&"
export * from "./TableauTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports